import  { useEffect } from "react";
import browserUpdate from "browser-update";

const BrowserUpdate = () => {
  useEffect(() => {
    // 1. Clean up any existing browser-update banners to avoid duplicate banners
    // (e.g. caused by React 18 Strict Mode rendering components twice in development)
    const removeExistingBanners = () => {
      const banners = document.querySelectorAll(".buorg");
      banners.forEach((banner) => banner.remove());
      
      // Also restore margins just in case
      const htmlEl = document.documentElement;
      const bodyEl = document.body;
      if (htmlEl) htmlEl.style.marginTop = "";
      if (bodyEl) bodyEl.style.marginTop = "";
    };

    removeExistingBanners();

    browserUpdate({
      required: { e: -2, f: -3, o: -3, s: -1, c: -3 }, // Required browser versions
      insecure: true,
      unsupported: true,
      text: "Your browser is outdated. Please update for a better experience.",
      reminder: 12,
      newwindow: true,
      // test: true,
      onshow: (info) => {
        console.log("Browser update message shown", info);

        // Wait for the update box to appear in the DOM
        setTimeout(() => {
          // Double-check and remove duplicate banners that might have been injected
          const banners = document.querySelectorAll(".buorg");
          if (banners.length > 1) {
            for (let i = 0; i < banners.length - 1; i++) {
              banners[i].remove();
            }
          }

          const updateBox = document.querySelector(".buorg"); // class used by browser-update
          if (updateBox && !updateBox.querySelector(".buorg-close")) {
            // Create close button
            const closeBtn = document.createElement("button");
            closeBtn.textContent = "×";
            closeBtn.className = "buorg-close";

            // Determine if the page layout is RTL to place close button on left side, otherwise right side
            const isRtl = document.documentElement.dir === "rtl" || document.body.dir === "rtl" || (window._buorgres && window._buorgres.ll === "ar");
            const sidePosition = isRtl ? "left: 15px;" : "right: 15px;";

            closeBtn.style.cssText = `
              position: absolute;
              top: 50%;
              ${sidePosition}
              transform: translateY(-50%);
              background: none;
              border: none;
              color: #333;
              font-size: 26px;
              font-weight: bold;
              cursor: pointer;
              z-index: 999999;
              line-height: 1;
              padding: 0;
              margin: 0;
              transition: color 0.2s ease;
            `;

            // Hover state for interactive styling
            closeBtn.onmouseenter = () => {
              closeBtn.style.color = "#ff5252";
            };
            closeBtn.onmouseleave = () => {
              closeBtn.style.color = "#333";
            };

            closeBtn.onclick = () => {
              updateBox.style.display = "none";
              const htmlEl = document.documentElement;
              const bodyEl = document.body;
              if (htmlEl) htmlEl.style.marginTop = "";
              if (bodyEl) bodyEl.style.marginTop = "";
            };

            updateBox.appendChild(closeBtn);
          }
        }, 200); // Small delay to ensure the banner is rendered
      },
    });

    return () => {
      // Clean up on component unmount
      removeExistingBanners();
    };
  }, []);

  return null;
};

export default BrowserUpdate;
